import {
  Box,
  Button,
  Color,
  Modal,
  OutlineEyeIcon,
  OutlineXmarkIcon,
  Spacing,
  Typography,
} from "kvweb-ui";
import {useEffect, useState} from "react";
import {useMediaQuery, useTheme} from "@mui/material";
import OutlineVipCustomerIcon from "../../../assets/icons/OutlineVipCustomerIcon";
import {useAdminMerchantContext} from "../../../contexts/adminMerchant/adminMerchant.context";
import {isEmpty} from "lodash";
import {useRouter} from "../../../utils/hooks/useRouter";
import {useAppSelector} from "../../../store/hooks";
import shopSlice, {
  ShopInformation,
  setIsOpenNotiEndSubscription,
} from "../../../store/slices/shopSlice";
import {useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import moment from "moment";
import {getPlatform} from "../../../utils/helper";
import {BOOKING_HOTEL_PLATFORM, BOOKING_PLATFORM, FNB_PLATFORM} from "../../../utils/constant";
import {useTranslation} from "react-i18next";

export interface IEndSubscriptionProps {
  retailData?: {
    branchInfo?: IRetailBranchInfo;
    merchantInfo?: IRetailMerchantInfo;
  };
  isHideButtonUpgrade?: boolean;
}

const ModalEndSubcriptionNotification = (props: IEndSubscriptionProps) => {
  const {retailData} = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const theme = useTheme();
  const {retail} = useAdminMerchantContext();
  const router = useRouter();
  const localtion = useLocation();
  const [currentRetailInfo, setCurrentRetailInfo] = useState<{
    branchInfo?: IRetailBranchInfo;
    merchantInfo?: IRetailMerchantInfo;
  }>();
  const shopInfo = useAppSelector(ShopInformation);
  const dispatch = useDispatch();
  const [isCanBeAction, setIsCanBeAction] = useState<boolean>(true);
  const isRetail = router.query.platform === "retail";
  const platform = router.query.platform
  const {t} = useTranslation()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  const handleCloseModal = () => {
    let fromIframeOrAdmin = "iframe";

    if (localtion.pathname.includes("/admin-merchant")) {
      fromIframeOrAdmin = "admin-merchant";
    }
    localStorage.setItem(
      `end-sub-status-${fromIframeOrAdmin}`,
      JSON.stringify({
        isOpenNotiEndSubscription: false,
        isShopInactive: shopInfo.isShopInactive
          ? true
          : shopInfo.isShopInactive,
        timeIsOpen: moment(new Date()),
      })
    );
    dispatch(setIsOpenNotiEndSubscription({value: false}));
    if (!isCanBeAction) return;
    setIsOpen(false);
  };

  useEffect(() => {
    // if (router.query.platform !== "retail") {
    //   setIsOpen(false);
    //   dispatch(setIsOpenNotiEndSubscription({value: false}));
    // }
    setCurrentRetailInfo(retail);
    if (isEmpty(retail)) {
      setCurrentRetailInfo(retailData);
    }
  }, [retailData]);

  useEffect(() => {
    setIsCanBeAction(!shopInfo.isShopInactive);
    if (localtion.pathname.includes("/admin-merchant")) {
      if (shopInfo.isOpenNotiEndSubscription) {
        setIsOpen(shopInfo.isOpenNotiEndSubscription);
      }
      return;
    }
    if (shopInfo.isOpenNotiEndSubscription) {
      setIsOpen(shopInfo.isOpenNotiEndSubscription);
    }
  }, [shopInfo, localtion.pathname]);

  const handleLearnMore = () => {
    let url = retail?.is_keivi_region ? `https://www.keivi.com/pricing/retail` : `https://www.kiotviet.vn/phi-dich-vu/`;
    switch (platform) {
      case BOOKING_PLATFORM:
        url = retail?.is_keivi_region ? `https://www.keivi.com/pricing/salon` : `https://kiotviet.vn/phi-dich-vu/quan-ly-hair-salon-nails`;
        break
      case FNB_PLATFORM:
        url = retail?.is_keivi_region ? `https://www.keivi.com/pricing/restaurant` : `https://www.kiotviet.vn/phi-dich-vu/`
        break
      case BOOKING_HOTEL_PLATFORM:
        url = `https://kiotviet.vn/phi-dich-vu/quan-ly-khach-san-nha-nghi`;
        break
    }
    window.open(url, "_blank");
  };

  const handleUpgradeNow = () => {
    if (isMobile) {
      //@ts-ignore
      window.upgradeSubscription(platform)
      return
    }
    let url = `https://${currentRetailInfo?.merchantInfo?.ref_code}.${retail?.is_keivi_region ? process.env.REACT_APP_RETAIL_KEIVI_KMA_DOMAIN_URL : process.env.REACT_APP_RETAIL_KMA_DOMAIN_URL}/man/#/KmaManagement#tab-product`;
    switch (platform) {
      case FNB_PLATFORM:
        url = `https://${retail?.is_keivi_region ? process.env.REACT_APP_FNB_KEIVI_KMA_DOMAIN_URL : process.env.REACT_APP_FNB_KMA_DOMAIN_URL}/${retail.branchInfo?.name}/#/KmaManagement#home`;
        break
      case BOOKING_PLATFORM:
        url = `https://${retail?.is_keivi_region ? process.env.REACT_APP_KEIVI_BOOKING_INDUSTRY : process.env.REACT_APP_BOOKING_INDUSTRY}/${currentRetailInfo?.merchantInfo?.ref_code}/#/KmaManagement#home`;
        break
      case BOOKING_HOTEL_PLATFORM:
        url = `https://${process.env.REACT_APP_BOOKING_INDUSTRY_HOTEL}/${currentRetailInfo?.merchantInfo?.ref_code}/#/KmaManagement#home`;
        break
    }
    window.open(url);
  };
  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleCloseModal}
        sxDialog={{
          padding: 0,
        }}
      >
        <Box
          sx={{
            position: "relative",
            padding: Spacing["space-xl"],
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              style={{
                marginBottom: '-10px',
                height: isMobile ? '220px' : '260px',
              }}
              src={retail.is_keivi_region ? '/img/retail/keivi-shop-end-of-subscription.png' : '/img/retail/shop-end-of-subscription.png'}
            />
          </Box>
          {isCanBeAction && (
            <Box
              sx={{
                width: "fit-content",
                position: "absolute",
                top: 20,
                right: 20,
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              <OutlineXmarkIcon/>
            </Box>
          )}
          <Box
            sx={{
              paddingY: Spacing["space-l"],
              textAlign: "center",
            }}
          >
            <Typography textType="text20S" color={Color["black-850"]}>
              {t('COMMON.YOUR_WEBSITE_IS_EXPIRED')}
            </Typography>
          </Box>
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography textType="text14R" color={Color["black-750"]} sx={{
              whiteSpace: 'wrap'
            }}>
              {
                platform === BOOKING_HOTEL_PLATFORM
                  ? t('COMMON.PACKAGE.PLEASE_UPGRADE_YOUR_PACKAGE_TO_HAVE_BEST_EXPERIENCE_HOTEL')
                  : t('COMMON.PACKAGE.PLEASE_UPGRADE_YOUR_PACKAGE_TO_HAVE_BEST_EXPERIENCE')
              }
            </Typography>
          </Box>
        </Box>
        {isCanBeAction && (
          <Box
            sx={{
              padding: Spacing["space-xl"],
              paddingTop: 0,
              [theme.breakpoints.up("md")]: {
                display: "flex",
                justifyContent: "end",
              },
            }}
          >
            <Box
              sx={{
                [theme.breakpoints.up("md")]: {
                  display: "flex",
                },
              }}
            >
              <Button
                btnType={"outlined"}
                size="large"
                sx={{
                  [theme.breakpoints.up("md")]: {
                    marginRight: Spacing["space-m"],
                  },
                  [theme.breakpoints.down("md")]: {
                    width: "100%",
                    marginBottom: Spacing["space-m"],
                  },
                }}
                onClick={handleLearnMore}
              >
                {t("COMMON.LEARN_ABOUT")}
              </Button>
              <Button
                startIcon={<OutlineVipCustomerIcon/>}
                sx={{
                  [theme.breakpoints.down("md")]: {
                    width: "100%",
                  },
                }}
                onClick={handleUpgradeNow}
                size="large"
              >
                {t('COMMON.UPGRADE_NOW')}
              </Button>
            </Box>
          </Box>
        )}
      </Modal>
    </>
  );
};

export default ModalEndSubcriptionNotification;
